import * as React from "react";

const SvgIcnSadFace = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
        <g clipPath="url(#clip0_3756_154352)">
            <path
                d="M5.43025 6.28578C5.27245 6.28578 5.14453 6.15786 5.14453 6.00007C5.14453 5.84228 5.27245 5.71436 5.43025 5.71436"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.42969 6.28578C5.58748 6.28578 5.7154 6.15786 5.7154 6.00007C5.7154 5.84228 5.58748 5.71436 5.42969 5.71436"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5728 6.28578C10.415 6.28578 10.2871 6.15786 10.2871 6.00007C10.2871 5.84228 10.415 5.71436 10.5728 5.71436"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5723 6.28578C10.7301 6.28578 10.858 6.15786 10.858 6.00007C10.858 5.84228 10.7301 5.71436 10.5723 5.71436"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.00084 15.4284C12.1036 15.4284 15.4294 12.1026 15.4294 7.99986C15.4294 3.89717 12.1036 0.571289 8.00084 0.571289C3.89815 0.571289 0.572266 3.89717 0.572266 7.99986C0.572266 12.1026 3.89815 15.4284 8.00084 15.4284Z"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.57227 11.4283C5.08399 9.7962 7.02855 8.79882 8.97312 9.25217C10.0989 9.52419 11.02 10.3402 11.4294 11.4283"
                stroke="#606B85"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_3756_154352">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default SvgIcnSadFace;
